<div class="offering-services-and-requests">
  <h1 class="ui-heading-1-bold">
    {{ section() }}
  </h1>

  @for (type of uniqueTypes; track $index) {
    <h3 class="ui-heading-3 mt-4">{{ type }}</h3>
    <div class="cards">
      @for (serviceAndRequest of servicesAndRequests(); track $index) {
        @if (serviceAndRequest.type === type) {
          <div class="card">
            <div class="ui-heading-4 mb-5">
              {{ serviceAndRequest.title }}
            </div>
            <div class="card-content ui-body-l mb-5">
              {{ serviceAndRequest.description }}
            </div>
            <div class="card-footer">
              <button
                [id]="getStartedId($index)"
                rds-primary-button
                size="l"
                [disabled]="isLoading"
                [attr.aria-label]="isLoading ? BUTTONS.GET_STARTED : null"
                faroAction="service request get started"
                [faroActionAttrs]="{
                  requestTitle: serviceAndRequest.title,
                  requestType: serviceAndRequest.type
                }"
                (click)="getStarted(serviceAndRequest)"
              >
                <!-- loading state -->
                @if (isLoading) {
                  <div class="spinner-container">
                    <rds-progress-spinner class="loading-spinner" aria-hidden="true"></rds-progress-spinner>
                  </div>
                } @else {
                  {{ BUTTONS.GET_STARTED }}
                  @if (opensInNewTab(serviceAndRequest)) {
                    <span class="sr-only">{{ NEW_TAB_SR }}</span>
                  }
                }
              </button>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
